import Button from 'react-bootstrap/Button'
import Form from 'react-bootstrap/Form'
import Modal from 'react-bootstrap/Modal'

function ConfirmationApplyProfileModal({ show, handleCancel, handleSubmit, sortedProfiles, selectedUtgsSignal, selectedProfileSignal }) {

    const SelectOptions = function ({ profiles }) {
        let options = []
        for (let i = 0; i < profiles.length; i++) {
            const profile = profiles[i]
            options.push(
                <option key={profile.id} value={profile.id}>
                    {profile.name} ({profile.config.utgGlobal.ccschema ? profile.config.utgGlobal.ccschema : 'Schema NOT Validated'})
                </option>
            )
        }
        return options
    }

    if (!sortedProfiles.length) {
        return
    }
    return (
        <Modal show={show} onHide={handleCancel}>
            <Modal.Header closeButton>
                <Modal.Title>Apply Profile to Selected UTGs</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>Choose a profile to assign to the selected UTG(s). When the selected profile is applied, the configuration profile for each UTG will immediately have the specified changes made in Shift4 Command Center. Each impacted UTG will require the &quot;Configuration Changes - Update UTG&quot; task to be scheduled in order for the changes to take effect. Please note, this will override any previously applied profiles.</p>
                <Form>
                    <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                        <Form.Label>Profile Name</Form.Label>
                        <Form.Select aria-label="Profile"
                            required
                            defaultValue={selectedProfileSignal.value.id}
                            onChange={(e) => selectedProfileSignal.value = e.target.value}
                        >
                            <SelectOptions profiles={sortedProfiles}></SelectOptions>
                        </Form.Select>
                    </Form.Group>
                </Form>
                <p>This profile will be applied to {selectedUtgsSignal.value.length} UTGs</p>
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={handleCancel}>
                    Cancel
                </Button>
                <Button variant="danger" onClick={handleSubmit}>
                    Submit
                </Button>
            </Modal.Footer>
        </Modal>
  )
}

export default ConfirmationApplyProfileModal;

